import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Card } from "semantic-ui-react";
import MediaItem from "~/models/Media/MediaItem";
import CustomDndProvider from "~/components/CustomDndProvider";
import SortableMedia from "./SortableMedia";

const MediaList = observer(
  ({
    mediaItems,
    inlineFormStores,
    draggingItemId,
    onEdit,
    reorder,
    onItemDragEnd,
    onItemDragBegin,
    onSubmit,
    onClick,
    onCancelEdit,
  }) => (
    <CustomDndProvider>
      <Card.Group size="small" className="media-edit-list" itemsPerRow={2}>
        {mediaItems.map(mediaItem => (
          <SortableMedia
            key={mediaItem.mediaItemId}
            mediaItem={mediaItem}
            formStore={inlineFormStores[mediaItem.mediaItemId]}
            draggingItemId={draggingItemId}
            onEdit={() => onEdit(mediaItem)}
            reorder={reorder}
            onItemDragEnd={onItemDragEnd}
            onItemDragBegin={onItemDragBegin}
            onClick={onClick}
            onSubmit={event => onSubmit(mediaItem.mediaItemId, event)}
            onCancelEdit={() => onCancelEdit(mediaItem.mediaItemId)}
            isInlineEditing={mediaItem.isEditing}
            onInlineEdit={() => mediaItem.setIsEditing(true)}
          />
        ))}
      </Card.Group>
    </CustomDndProvider>
  ),
);

MediaList.propTypes = {
  mediaItems: PropTypes.arrayOf(PropTypes.instanceOf(MediaItem)),
  inlineFormStores: PropTypes.object,
  draggingItemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onEdit: PropTypes.func.isRequired,
  reorder: PropTypes.func.isRequired,
  onItemDragEnd: PropTypes.func.isRequired,
  onItemDragBegin: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
};

export default MediaList;
